import { useEffect } from "react";

function RedirectToApp({ isShowLoader }) {

  useEffect(() => {

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Android detection
    if (/android/i.test(userAgent)) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.otobix.customerapp";
    }

    // iOS detection
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = "https://apps.apple.com/app/id6754752912";
    }

    // Other OS (Windows, Mac, etc.)
    else {
      window.location.href = "/";
    }
    isShowLoader(false);


  }, []);

  return (
    <div className="mainbodycls">
      <h1>Redirecting...</h1>
    </div>
  );
}

export default RedirectToApp;